/**
 * Appends page and size query params to an API URL.
 */
export function appendPaginationQuery(url, page, size) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}page=${page}&size=${size}`;
}
